import { Component, OnInit } from '@angular/core';
import { DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { SessionExpirationDialogComponent } from './session-expiration-dialog/session-expiration-dialog.component';
import { SessionService } from './service/session.service';
import { GemsHttpService } from '../../services/gems-http.service';
import { IdleService } from '../../services/idle.service';
import { KeepAliveService } from '../../services/keep-alive.service';
import { GemsService } from '../../services';
import { concatMap } from 'rxjs/operators';


@Component({
  selector: 'app-session-expiration',
  templateUrl: 'session-expiration.component.html',
  styleUrls: ['session-expiration.component.less'],
  standalone: false
})
export class SessionExpirationComponent implements OnInit {

  idleState: string;
  timedOut: boolean;
  lastPing?: Date;
  countdown: any;

  constructor(
    private idleService: IdleService,
    private keepAliveService: KeepAliveService,
    private bsModalService: BsModalService,
    private sessionService: SessionService,
    private gemsService: GemsService,
    private gemsHttpService: GemsHttpService
  ) {

    // open prompt if user is idle for 20 minutes(1200 sec).
    idleService.setIdle(1200);

    // once prompt is open, give user 10 minutes(600 sec) to respond. after 20 minutes of inactivity, the user will be considered timed out.
    idleService.setTimeout(600);

    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    idleService.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idleService.onIdleEnd.subscribe(this.onIdleEnd.bind(this));
    idleService.onTimeout.subscribe(this.onTimeOut.bind(this));
    idleService.onIdleStart.subscribe(this.onIdleStart.bind(this));
    idleService.onTimeoutWarning.subscribe(this.onTimeoutWarning.bind(this));

    // sets the ping interval to 5 min
    this.keepAliveService.interval(300);

    this.keepAliveService.onPing.subscribe(this.onPing.bind(this));

    this.reset();

    sessionService.keepMeLoggedIn$.subscribe(
      tick => {
        this.reset();
      });
  }

  ngOnInit() {
    this.idleState = 'Not started.';
    this.timedOut = false;
    this.lastPing = null;
  }

  reset() {
    this.idleService.setInterrupts(DEFAULT_INTERRUPTSOURCES);
    this.idleService.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
  }

  onIdleEnd() {
    this.idleState = 'No longer idle.';
    this.sessionService.onIdleEnd();
  }

  onTimeOut() {
    this.idleState = 'Timed out!';
    this.timedOut = true;
    this.sessionService.timedOut();
  }

  onIdleStart() {
    this.idleState = "You've gone idle!";
    this.idleService.clearInterrupts(); // stop interrupts once dialog ahs appeared
    const ignoreBackdropClick = true;
    this.bsModalService.show(SessionExpirationDialogComponent, {
      ignoreBackdropClick
    });

  }

  onTimeoutWarning(countdown: number) {
    this.sessionService.nextTick(countdown);
    this.countdown = countdown;
  }

  onPing() {
    this.lastPing = new Date();
    this.keepAlive();
  }

  keepAlive() {
    this.gemsService.siteMap().pipe(
      concatMap(sitemap => this.gemsHttpService.get(sitemap.keep_alive_url))
    ).subscribe();
  }
}
